module.exports = __webpack_public_path__ + "img/result.4a34c03f.png";